import type { TFormatMessage } from '@zennolab_platform/webui-sdk/dist/hooks/useFormatMessage';
import type { ReactElement } from 'react';

import { AnnouncementsSection } from '../AnnouncementsSection';

export interface Section {
  /** First URL segment; the section owns the whole subtree `/<path>/*`. */
  path: string;
  /** Keycloak realm role required to open the section. */
  role: string;
  title: (t: TFormatMessage) => string;
  element: ReactElement;
}

/** The one place where admin sections are registered. */
export const sections: Section[] = [
  {
    path: 'announcements',
    role: 'zennobrowser_announcements_admin',
    title: t =>
      t({
        id: 'shell.nav.announcements',
        defaultMessage: 'Анонсы',
        description: 'Раздел админки в боковом меню и заголовок списка',
      }),
    element: <AnnouncementsSection />,
  },
];
